import { v4 as uuid } from 'uuid';
import { getStaticTranslationsAPI } from "./api";

async function getStaticTranslations () {
    
    const env = this.env;
    const appStore = env.appStore;
    let locale = appStore.locale;
    if ( appStore.widget?.language && appStore.widget?.language !== 'auto') {
        locale = appStore.widget?.language;
    }
    const res = await getStaticTranslationsAPI({
        traceId: env.traceId,
        locale,
        store: this,
    });

    this.translations = res.data;

    // console.log('getTranslations() Response', this.translations);
    this.observed.translations = uuid();

}

export default getStaticTranslations;